import {customElement, property} from "lit/decorators.js";
import {css, html, LitElement} from "lit";

@customElement('app-bible-verse')
export class BibleVerse extends LitElement {
  createRenderRoot = () => this

  @property() osisID: string = '';
  @property() verseNum: string = '';
  @property() verseHtml: string = '';

  render() {
    this.id = this.osisID.replaceAll('.', '-');
    this.setAttribute('data-osis', this.osisID);

    return html`<span class="verse" @click=${this._onClick}>
      <sup>${this.verseNum}</sup>
      <span .innerHTML=${this.verseHtml}></span>
    </span>`;
  }

  private _onClick() {
    this.dispatchEvent(new CustomEvent('verse-clicked', {
      bubbles: true, composed: true,
      detail: {
        osis: this.osisID,
        text: this.textContent?.trim().substring(0, 100) || ''
      }
    }));
  }
}

@customElement('bible-footnote')
export class BibleFootnote extends LitElement {
  static styles = css`
    :host {
      display: inline-block;
      position: relative;
      cursor: pointer;
      font-size: 0.9em;
    }
    .footnote-icon {
      font-size: 0.7em;
      vertical-align: super;
      color: var(--text-tertiary, #999);
      margin-left: 2px;
      opacity: 0.7;
    }
    :host(:hover) .footnote-icon {
      opacity: 1;
      color: var(--accent, #2563eb);
    }
    .tooltip {
      visibility: hidden;
      opacity: 0;
      background-color: var(--bg-surface, #fff);
      color: var(--text-primary, #333);
      text-align: left;
      padding: 10px 12px;
      border-radius: 8px;
      border: 1px solid var(--border-subtle, #e7e5e4);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      position: absolute;
      z-index: 100;
      top: 1.5em;
      left: 0;
      width: max-content;
      max-width: 280px;
      font-family: var(--font-ui, system-ui, sans-serif);
      font-size: 0.85rem;
      line-height: 1.5;
      transition: opacity 150ms ease, visibility 150ms ease;
    }

    :host(:hover) .tooltip {
      visibility: visible;
      opacity: 1;
    }

    ::slotted(*) {
      display: none;
    }
  `
  protected render(): unknown {
    return html`<span class="footnote-icon">†</span> <span class="tooltip"><slot></slot></span>`
  }
}
